// Контекст транспорта (SPEC §4.0/§4.6). app-ui СОЗДАЁТ один Transport (client-transport §4.1) и
// отдаёт его: (а) стору через store.attach(transport), (б) экранам — для прямых rest.* запросов к
// НЕ-стор-данным (auth/директория/поиск/сессии/админка/upload, SPEC §2/§4.0). Доменное (чаты/
// сообщения) экраны НЕ дёргают через rest напрямую — только через стор (инв.2). Это единственный
// сетевой шлюз: прямого fetch/WebSocket в app-ui нет (страж-тест §4.8).

import { createContext, useContext, type ReactNode } from 'react'
import type { Transport } from '@tele-chat/client-transport'

const TransportContext = createContext<Transport | null>(null)

export interface TransportProviderProps {
  transport: Transport
  children: ReactNode
}

export function TransportProvider({ transport, children }: TransportProviderProps): JSX.Element {
  return <TransportContext.Provider value={transport}>{children}</TransportContext.Provider>
}

/** Доступ к транспорту. Бросает вне TransportProvider. */
export function useTransport(): Transport {
  const t = useContext(TransportContext)
  if (t === null) {
    throw new Error('useTransport(): компонент должен быть внутри <TransportProvider>')
  }
  return t
}

/** REST-клиент транспорта — для не-стор-данных (auth/directory/search/sessions/admin/upload). */
export function useRest(): Transport['rest'] {
  return useTransport().rest
}
